import withIcon from './NewIcon';
// @ts-ignore
import IconContacts from './icon/m/contacts.svg';

export default withIcon(IconContacts);
